import { render } from "./CriarFichaMedica.vue?vue&type=template&id=5be2b3e6&scoped=true"
import script from "./CriarFichaMedica.vue?vue&type=script&lang=js"
export * from "./CriarFichaMedica.vue?vue&type=script&lang=js"

import "./CriarFichaMedica.vue?vue&type=style&index=0&id=5be2b3e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be2b3e6"]])

export default __exports__